(function () {
  var root = document.getElementById("ms-track-order");
  if (!root) return;
  var form = root.querySelector("[data-track-form]");
  var result = root.querySelector("[data-track-result]");
  var resultTitle = root.querySelector("[data-track-result-title]");
  var resultMessage = root.querySelector("[data-track-result-message]");
  var resultBody = root.querySelector("[data-track-result-body]");
  var submit = root.querySelector("[data-track-submit]");
  var again = root.querySelector("[data-track-again]");
  var orderField = root.querySelector("[data-track-order]");
  var loading = root.querySelector("[data-track-loading]");
  var API = (root.getAttribute("data-api") || "").replace(/\/+$/, "");
  if (!form || !result || !API) return;

  var params = new URLSearchParams(window.location.search);
  if (orderField && params.get("order")) orderField.value = params.get("order");

  function esc(value) {
    return String(value == null ? "" : value).replace(/[&<>"']/g, function (char) {
      return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[char];
    });
  }

  function pretty(value) {
    var raw = String(value || "").replace(/[_]+/g, " ").replace(/\s+/g, " ").trim();
    if (!raw) return "";
    if (raw === raw.toUpperCase() || raw === raw.toLowerCase()) {
      return raw.toLowerCase().replace(/\b[a-z]/g, function (char) {
        return char.toUpperCase();
      });
    }
    return raw;
  }

  function whenParts(iso) {
    var date = new Date(iso);
    if (Number.isNaN(date.getTime())) return null;
    var zone = "Asia/Kolkata";
    return {
      date: new Intl.DateTimeFormat("en-IN", { timeZone: zone, day: "numeric", month: "short", year: "numeric" }).format(date),
      time: new Intl.DateTimeFormat("en-IN", { timeZone: zone, hour: "numeric", minute: "2-digit", hour12: true }).format(date) + " IST",
    };
  }

  function originScan(scan) {
    var blob = ((scan.status || "") + " " + (scan.remark || "")).toLowerCase().replace(/[_-]+/g, " ");
    return /ready\s*for\s*dispatch|order\s*confirmed|\bmanifested\b|\bbooked\b|pickup initiated|pick up initiated/.test(blob);
  }

  function setError(name, message) {
    var node = root.querySelector('[data-track-error="' + name + '"]');
    if (node) node.textContent = message || "";
  }

  function clearErrors() {
    root.querySelectorAll("[data-track-error]").forEach(function (node) {
      node.textContent = "";
    });
  }

  function setLoading(on) {
    if (loading) loading.hidden = !on;
    if (submit) submit.disabled = on;
  }

  function showStep(next) {
    root.classList.toggle("is-wide", next === "status");
    root.querySelectorAll("[data-track-step]").forEach(function (pane) {
      pane.hidden = pane.getAttribute("data-track-step") !== next;
    });
    var order = { lookup: 0, status: 1 };
    root.querySelectorAll("[data-track-pip]").forEach(function (pip) {
      var id = pip.getAttribute("data-track-pip");
      pip.classList.toggle("is-active", id === next);
      pip.classList.toggle("is-done", order[id] < order[next]);
    });
  }

  function tone(milestone) {
    if (milestone === "delivered") return "valid";
    if (milestone === "cancelled" || milestone === "returned" || milestone === "delivery_failed") return "invalid";
    return "already";
  }

  function courierOf(name) {
    var key = String(name || "").toLowerCase();
    if (/maruti/.test(key)) return "maruti";
    if (/blue\s?dart/.test(key)) return "bluedart";
    if (/dtdc/.test(key)) return "dtdc";
    if (/delhivery/.test(key)) return "delhivery";
    if (/xpress\s?bees/.test(key)) return "xpressbees";
    if (/amazon/.test(key)) return "amazon";
    if (/india\s?post|speed\s?post/.test(key)) return "indiapost";
    if (/shadowfax/.test(key)) return "shadowfax";
    if (/ekart/.test(key)) return "ekart";
    if (/ecom/.test(key)) return "ecom";
    return "generic";
  }

  function logo(id) {
    var box = '<svg viewBox="0 0 48 48" aria-hidden="true">';
    if (id === "maruti") {
      return box + '<rect width="48" height="48" rx="12" fill="#E10600"/><path fill="#fff" d="M9 33V15h6.2l4.6 10.2L24.4 15H31v18h-4.2V22.4L22.2 33h-3.2l-4.6-10.6V33H9z"/><circle cx="36.5" cy="30" r="3.2" fill="#FFD100"/></svg>';
    }
    if (id === "bluedart") {
      return box + '<rect width="48" height="48" rx="12" fill="#0033A0"/><path fill="#fff" d="M12 30.5 24 10l12 20.5h-7.2L24 20.8 19.2 30.5H12z"/></svg>';
    }
    if (id === "dtdc") {
      return box + '<rect width="48" height="48" rx="12" fill="#C8102E"/><text x="24" y="30" text-anchor="middle" fill="#fff" font-family="Arial,sans-serif" font-size="13" font-weight="700">DTDC</text></svg>';
    }
    if (id === "delhivery") {
      return box + '<rect width="48" height="48" rx="12" fill="#EF3E42"/><text x="24" y="31" text-anchor="middle" fill="#fff" font-family="Arial,sans-serif" font-size="22" font-weight="700">d</text></svg>';
    }
    if (id === "xpressbees") {
      return box + '<rect width="48" height="48" rx="12" fill="#111"/><path fill="#FFC20E" d="M10 31c6-10 10-14 14-14s8 4 14 14H10z"/><circle cx="18" cy="33" r="2.4" fill="#fff"/><circle cx="30" cy="33" r="2.4" fill="#fff"/></svg>';
    }
    if (id === "amazon") {
      return box + '<rect width="48" height="48" rx="12" fill="#232F3E"/><path d="M14 28c6 5 14 5 20 0" fill="none" stroke="#FF9900" stroke-width="2.4" stroke-linecap="round"/><path d="M31 25.5l4 3.2-5.2.6" fill="#FF9900"/></svg>';
    }
    if (id === "indiapost") {
      return box + '<rect width="48" height="48" rx="12" fill="#B01E28"/><circle cx="24" cy="22" r="7" fill="none" stroke="#F4C430" stroke-width="2"/><path d="M16 34h16" stroke="#fff" stroke-width="2" stroke-linecap="round"/></svg>';
    }
    if (id === "shadowfax") {
      return box + '<rect width="48" height="48" rx="12" fill="#F26522"/><path fill="#fff" d="M14 32V16h4l6 10V16h4v16h-4l-6-10v10h-4z"/></svg>';
    }
    if (id === "ekart") {
      return box + '<rect width="48" height="48" rx="12" fill="#F7D117"/><path fill="#111" d="M14 30 24 14l10 16h-5l-5-8-5 8h-5z"/></svg>';
    }
    if (id === "ecom") {
      return box + '<rect width="48" height="48" rx="12" fill="#F36F21"/><text x="24" y="30" text-anchor="middle" fill="#fff" font-family="Arial,sans-serif" font-size="13" font-weight="700">ECOM</text></svg>';
    }
    return box + '<rect width="48" height="48" rx="12" fill="#ff6633"/><path fill="#fff" d="M12 29h17l3-6H18l-1.4-3H12v3h3.2L17 29H12zm18.5 2.5a2.2 2.2 0 1 0 0.1 0zm-11 0a2.2 2.2 0 1 0 0.1 0z"/></svg>';
  }

  function glyph(name) {
    if (name === "cal") {
      return '<svg viewBox="0 0 24 24" aria-hidden="true"><rect x="4" y="5" width="16" height="15" rx="2"></rect><path d="M8 3.5v4M16 3.5v4M4 10h16"></path></svg>';
    }
    return '<svg viewBox="0 0 24 24" aria-hidden="true"><circle cx="12" cy="12" r="8"></circle><path d="M12 8v5l3 2"></path></svg>';
  }

  function cells(iso) {
    var parts = iso ? whenParts(iso) : null;
    if (!parts) {
      return '<span class="ms-track-cell ms-track-cell-date"></span><span class="ms-track-cell ms-track-cell-time"></span>';
    }
    return (
      '<span class="ms-track-cell ms-track-cell-date">' + glyph("cal") + "<span>" + esc(parts.date) + "</span></span>" +
      '<span class="ms-track-cell ms-track-cell-time">' + glyph("clock") + "<span>" + esc(parts.time.replace(/\s*IST$/, "")) + "</span></span>"
    );
  }

  function eventList(scans) {
    if (!scans || !scans.length) return "";
    return (
      '<div class="ms-track-table">' +
      '<div class="ms-track-thead" aria-hidden="true"><span>Status</span><span>Date</span><span>Time (IST)</span></div>' +
      '<ol class="ms-track-rows">' +
      scans.map(function (scan, index) {
        var title = pretty(scan.remark) || pretty(scan.status) || "Update";
        var status = pretty(scan.status);
        var location = originScan(scan) ? "" : (scan.location || "");
        var meta = [status && status.toLowerCase() !== title.toLowerCase() ? status : "", location].filter(Boolean).join(" · ");
        return (
          '<li class="ms-track-row' + (index === 0 ? " is-latest" : "") + '" style="--ms-track-i:' + index + '">' +
          '<span class="ms-track-cell ms-track-cell-status">' +
          '<span class="ms-track-dot" aria-hidden="true"></span>' +
          "<span><span class=\"ms-track-row-title\">" + esc(title) + "</span>" +
          (meta ? '<span class="ms-track-row-meta">' + esc(meta) + "</span>" : "") +
          "</span></span>" +
          cells(scan.at) +
          "</li>"
        );
      }).join("") +
      "</ol></div>"
    );
  }

  function shipmentBlock(shipment, orderName) {
    var carrier = shipment.carrier || "Courier";
    var id = courierOf(shipment.carrier);
    var name = orderName || "Your order";
    if (name.charAt(0) !== "#") name = "#" + name;
    var label = shipment.label || "Update";
    var detail = shipment.detail && shipment.detail !== label ? shipment.detail : "";
    var updated = shipment.lastScanAt ? whenParts(shipment.lastScanAt) : null;
    return (
      '<section class="ms-track-board">' +
      '<div class="ms-track-head">' +
      '<div><p class="ms-track-caption">Order</p><p class="ms-track-order-id">' + esc(name) + "</p></div>" +
      '<div class="ms-track-partner">' +
      '<span><p class="ms-track-caption">Courier partner</p>' +
      '<p class="ms-track-courier-name">' + esc(carrier) + "</p>" +
      (shipment.waybill ? '<p class="ms-track-awb">AWB ' + esc(shipment.waybill) + "</p>" : "") +
      "</span>" +
      '<span class="ms-track-logo" title="' + esc(carrier) + '">' + logo(id) + "</span>" +
      "</div></div>" +
      '<div class="ms-track-now" data-milestone="' + esc(shipment.milestone || "") + '">' +
      '<div><p class="ms-track-caption">Current status</p><p class="ms-track-status">' + esc(label) + "</p>" +
      (detail ? '<p class="ms-track-detail">' + esc(detail) + "</p>" : "") +
      "</div>" +
      (updated
        ? '<div class="ms-track-now-when"><p class="ms-track-caption">Last update</p><p class="ms-track-now-time">' +
          esc(updated.date) + " · " + esc(updated.time) + "</p></div>"
        : "") +
      "</div>" +
      eventList(shipment.scans) +
      "</section>"
    );
  }

  function render(tracking) {
    var shipments = (tracking && tracking.shipments) || [];
    var blocks = shipments.length ? shipments : [tracking || {}];
    var orderName = (tracking && tracking.orderName) || "";
    var body = blocks.map(function (shipment) {
      return shipmentBlock(shipment, orderName);
    }).join("");
    result.classList.add("is-timeline");
    result.setAttribute("data-status", tone(tracking && tracking.milestone));
    if (resultTitle) resultTitle.textContent = orderName || "Your order";
    if (resultMessage) resultMessage.textContent = "";
    if (resultBody) resultBody.innerHTML = body;
    showStep("status");
  }

  root.querySelectorAll("input").forEach(function (input) {
    input.addEventListener("input", function () {
      var name = input.getAttribute("name");
      if (name === "orderName") setError("orderName", "");
      if (name === "email" || name === "phone") setError("form", "");
    });
  });

  if (again) {
    again.addEventListener("click", function () {
      showStep("lookup");
      if (orderField) orderField.focus();
    });
  }

  form.addEventListener("submit", function (event) {
    event.preventDefault();
    var data = new FormData(form);
    var orderName = String(data.get("orderName") || "").trim();
    var email = String(data.get("email") || "").trim();
    var phone = String(data.get("phone") || "").trim();
    clearErrors();
    if (!orderName) {
      setError("orderName", "Enter your order number.");
      if (orderField) orderField.focus();
      return;
    }
    if (!email && !phone) {
      setError("form", "Enter the email or phone used at checkout.");
      return;
    }
    setLoading(true);
    fetch(API + "/api/track", {
      method: "POST",
      headers: { Accept: "application/json", "Content-Type": "application/json" },
      body: JSON.stringify({
        orderName: orderName,
        email: email,
        phone: phone,
      }),
    })
      .then(function (response) {
        return response.json().then(function (payload) {
          return { ok: response.ok, payload: payload };
        });
      })
      .then(function (outcome) {
        if (!outcome.ok || !outcome.payload || !outcome.payload.ok) {
          setError("form", (outcome.payload && outcome.payload.error) || "We could not look up that order. Try again.");
          return;
        }
        render(outcome.payload.tracking);
      })
      .catch(function () {
        setError("form", "We could not look up that order. Try again.");
      })
      .then(function () {
        setLoading(false);
      });
  });
})();
